import React, { useRef, useState } from "react";
import LoanProduct from "../LoanProducts";
import "./DivSlider.css";
import ContactIcon from "../../assets/Images/component/contactIcon.svg";
import EligibilityCriteria from "../../assets/Images/Home/EligibilityCriteria.png";
import DocumnetReq from "../../assets/Images/Home/Documnet-req.png"
import creditScore from "../../assets/Images/Home/creditScore.png"
import { LeftArrow, RightArrow } from "../../pages/LandingPage/components/SvgIcon";

const DivSLider = () => {
  const scrollRef = useRef(null);
  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      })
    }
  }
  const Products = [
    {
      title: "Eligibility Criteria",
      icon: ContactIcon,
      image: EligibilityCriteria,
      list: ["Age 21- 65", "Employment status"],
      color: {
        iconBg: "#DECEE5",
        contentBg: "#DECEE5",
        borderColor: "#6F4C9F",
      },
    },
    {
      title: "Eligibility Criteria",
      icon: ContactIcon,
      image: EligibilityCriteria,
      list: ["Age 21- 65", "Employment status"],
      color: {
        iconBg: "#DECEE5",
        contentBg: "#DECEE5",
        borderColor: "#6F4C9F",
      },
    },
    {
      title: "Documents Required",
      icon: ContactIcon,
      image: DocumnetReq,
      list: ["Pan card", "Aadhar card", "Address proof"],
      color: {
        iconBg: "#F0EFA2",
        contentBg: "#F0EFA254",
        borderColor: "#AB882E",
      },
    },
    {
      title: "Credit Score",
      icon: ContactIcon,
      image: creditScore,
      list: ["Age 21- 65", "Employment status"],
      color: {
        iconBg: "#9BD7D0",
        contentBg: "#9BD7D033",
        borderColor: "#9BD7D0",
      },
    },
  ]
  return (
    <div className="DivSLider-container">
          <div className="DivSLider-wrapper">
            <div
              ref={scrollRef}
              className={'DivSLider-item'}              
            >
              {Products?.map((item) => (
                <LoanProduct
                  icon={item?.icon}
                  title={item?.title}
                  thumbnail={item?.image}
                  list={item?.list}
                  color={item?.color}
                />
              ))}
            </div>
            {/* Left Arrow */}
            <div className="footer-scroll-button">
              <button onClick={() => scroll("left")} className="carsole-button">
                {LeftArrow}
              </button>

              {/* Right Arrow */}
              <button
                onClick={() => scroll("right")}
                className="carsole-button"
              >
                {RightArrow}
              </button>
            </div>
          </div>
        </div>
  );
};

export default DivSLider;
